/**
 * Identifies which calendar/athlete/program is currently being viewed, so an
 * async request can capture it at dispatch time and its FULFILLED handler can
 * tell whether the user has switched away in the meantime (e.g. an undo POST
 * still in flight when the user picks a different calendar - its response
 * must not write the previous selection's calendarAction back into state).
 *
 * Calendar is checked before athlete before program because selecting a
 * calendar or athlete doesn't clear selectedReduxNonDateBasedProgram - the
 * calendar/athlete selection is the one actually in view when both are set.
 *
 * @param {Object} calendarData - state.calendar.data
 * @returns {string | null} null when nothing is selected
 */
const getCalendarSelectionKey = (calendarData) => {
  if (calendarData?.selectedReduxCalendar?.id) {
    return `calendar:${calendarData.selectedReduxCalendar.id}`;
  }
  if (calendarData?.selectedReduxAthlete?.id) {
    return `athlete:${calendarData.selectedReduxAthlete.id}`;
  }
  if (calendarData?.selectedReduxNonDateBasedProgram?.id) {
    return `program:${calendarData.selectedReduxNonDateBasedProgram.id}`;
  }
  return null;
};

export default getCalendarSelectionKey;
